module.exports = __webpack_public_path__ + "assets/img/xcly.96180d1c.png";